/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://dh-static.mesos.nrk.no/chatlog/static/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nodelistToArray = nodelistToArray;
function nodelistToArray(nodeList) {
  return [].slice.call(nodeList);
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _domready = __webpack_require__(3);

var _domready2 = _interopRequireDefault(_domready);

var _nodelistToArray = __webpack_require__(0);

var _init = __webpack_require__(4);

__webpack_require__(6);

var _App = __webpack_require__(7);

var _Message = __webpack_require__(8);

var _Message2 = _interopRequireDefault(_Message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rootElementClassName = _App.root;

window[rootElementClassName] = window[rootElementClassName] || {};

var imgClass = _Message2.default.message__image;
var clickable = _Message2.default['message__image--clickable'];
var expanded = _Message2.default['message__image--expanded'];
var hover = _Message2.default['message__image--hover'];

function mountFn(el) {
  var imgs = (0, _nodelistToArray.nodelistToArray)(el.querySelectorAll('.' + imgClass));
  imgs.map(makeExpandable);
}

var onClick = function onClick(el, className) {
  return el.classList.toggle(className);
};
var onEnter = function onEnter(el, className, shouldHover) {
  return shouldHover && el.classList.add(className);
};
var onLeave = function onLeave(el, className) {
  return el.classList.remove(className);
};
var makeExpandable = function makeExpandable(el) {
  var isHoverable = true;
  el.classList.add(clickable);
  el.addEventListener('click', function () {
    return onClick(el, expanded);
  });
  el.addEventListener('touchstart', function () {
    return isHoverable = false;
  });
  el.addEventListener('mouseenter', function () {
    return onEnter(el, hover, isHoverable);
  });
  el.addEventListener('mouseleave', function () {
    return onLeave(el, hover);
  });
};
(0, _domready2.default)(function () {
  return (0, _init.init)(rootElementClassName, mountFn);
});

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
  * domready (c) Dustin Diaz 2014 - License MIT
  */
!function (name, definition) {

  if (true) module.exports = definition();else if (typeof define == 'function' && _typeof(define.amd) == 'object') define(definition);else this[name] = definition();
}('domready', function () {

  var fns = [],
      _listener,
      doc = document,
      hack = doc.documentElement.doScroll,
      domContentLoaded = 'DOMContentLoaded',
      loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState);

  if (!loaded) doc.addEventListener(domContentLoaded, _listener = function listener() {
    doc.removeEventListener(domContentLoaded, _listener);
    loaded = 1;
    while (_listener = fns.shift()) {
      _listener();
    }
  });

  return function (fn) {
    loaded ? setTimeout(fn, 0) : fns.push(fn);
  };
});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;

var _nodelistToArray = __webpack_require__(0);

var _uuid = __webpack_require__(5);

/* global __HOT__ */
function init(rootElementClassName, mountFn, callbackFn) {
  findElements(rootElementClassName).forEach(function (el) {
    el.id = (0, _uuid.uuid)();
    window[rootElementClassName][el.id] = true;

    // Extract preloaded state sent person server
    mountFn(el);

    // Enable webpack hot-reloading
    if (false) {
      // Reload CSS file

      require('webpack/hot/emitter').on('webpackHotUpdate', function (currentHash) {
        document.querySelectorAll('link[href][rel=stylesheet]').forEach(function (link) {
          var nextStyleHref = link.href.replace(/(\?\d+)?$/, '?' + Date.now());
          link.href = nextStyleHref;
        });
      });

      // Reload and re-render React application
      module.hot.accept('./index', function () {
        var _require = require('react'),
            ReactDOM = _require.ReactDOM;

        ReactDOM.hydrate(require('../shared/App').default, el);
      });
    }
  });
}

function findElements(rootElementClassName) {
  return (0, _nodelistToArray.nodelistToArray)(document.getElementsByClassName(rootElementClassName)).filter(function (el) {
    return !isInitialized(el, rootElementClassName);
  });
}

function isInitialized(el, rootElementClassName) {
  return el.id && window[rootElementClassName][el.id];
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uuid = uuid;
function uuid() {
  return "_" + Math.random().toString(36).substr(2, 9);
}

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"nrk-chatlog-root","app":"nrk-chatlog-app"};

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"message":"nrk-chatlog-message","message--left":"nrk-chatlog-message--left","message--is-display-avatar":"nrk-chatlog-message--is-display-avatar","message--right":"nrk-chatlog-message--right","message--is-last-in-group":"nrk-chatlog-message--is-last-in-group","message__text":"nrk-chatlog-message__text","message__text--right":"nrk-chatlog-message__text--right","message__text--left":"nrk-chatlog-message__text--left","message__image":"nrk-chatlog-message__image","message__image--expanded":"nrk-chatlog-message__image--expanded","message__image--clickable":"nrk-chatlog-message__image--clickable","message__image--hover":"nrk-chatlog-message__image--hover","message__image--left":"nrk-chatlog-message__image--left","message__image--right":"nrk-chatlog-message__image--right","message__name":"nrk-chatlog-message__name","message__content":"nrk-chatlog-message__content","message__content--left":"nrk-chatlog-message__content--left","message__content--right":"nrk-chatlog-message__content--right","message__content--has-name":"nrk-chatlog-message__content--has-name"};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle-b3635172805f85434e67.js